import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b9662bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "filters ion-padding-top" }
const _hoisted_3 = { class: "jobs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "ion-text-center ion-padding"
}
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { slot: "start" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Audit")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        ref: "contentRef",
        "scroll-events": true,
        onIonScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enableScrolling()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_searchbar, {
                    placeholder: _ctx.$t('Search products'),
                    modelValue: _ctx.queryString,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryString) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => {_ctx.queryString = $event.target.value; _ctx.getCatalogProducts()}, ["enter"]))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
                        return (_openBlock(), _createBlock(_component_ion_chip, {
                          outline: _ctx.prodCatalogCategoryTypeId !== filter.value,
                          key: filter.value,
                          onClick: ($event: any) => (_ctx.applyFilter(filter.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(filter.name)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["outline", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ion_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Jobs')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('Pre-sell computation')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.preordBckordComputationJob.lastRunTime && _ctx.timeTillJob(_ctx.preordBckordComputationJob.lastRunTime)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.preordBckordComputationJob.runTime ? _ctx.timeTillJob(_ctx.preordBckordComputationJob.runTime) : _ctx.$t('disabled')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_4,
          (!_ctx.products.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('No products found')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    button: "",
                    detail: "",
                    key: product.productId,
                    onClick: ($event: any) => (_ctx.viewProduct(product))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxpShopifyImg, {
                            src: product.mainImageUrl,
                            size: "small"
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, product) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, product) : product.productName) + " ", 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, product)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (_ctx.hasPresellCategory(product))
                        ? (_openBlock(), _createBlock(_component_ion_chip, {
                            key: 0,
                            slot: "end",
                            class: "tablet",
                            outline: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(product.prodCatalogCategoryTypeIds.includes('PCCT_PREORDR') ? _ctx.$t('Pre-order') : product.prodCatalogCategoryTypeIds.includes('PCCT_BACKORDER') ? _ctx.$t('Back-order') : '-'), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_chip, {
                        slot: "end",
                        class: "tablet",
                        outline: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getInventoryChipLabel(product)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                  onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreProducts($event))),
                  threshold: "1000px",
                  ref: "infiniteScrollRef"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_infinite_scroll_content, {
                      "loading-spinner": "crescent",
                      "loading-text": _ctx.$t('Loading')
                    }, null, 8, ["loading-text"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.isCatalogScrollable]
                ])
              ]))
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}